import { createContext, useState } from "react";

export const RequestLookupContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [requestLookupBHXHs, setRequestLookupBHXHs] = useState([]);
    const [requestLookupBHYTs, setRequestLookupBHYTs] = useState([]);
    const [requestLookupDKYXEs, setRequestLookupDKYXEs] = useState([]);
    const [requestLookupGPLXs, setRequestLookupGPLXs] = useState([]);
    const [requestLookupTHUECNs, setRequestLookupTHUECNs] = useState([]);
    const [requestLookupDialog, setRequestLookupDialog] = useState(false);
    const [requestLookupData, setRequestLookupData] = useState(null);

    // Make the context object:
    const requestLookupContext = {
        requestLookupBHXHs,
        setRequestLookupBHXHs,
        requestLookupBHYTs,
        setRequestLookupBHYTs,
        requestLookupDKYXEs,
        setRequestLookupDKYXEs,
        requestLookupGPLXs,
        setRequestLookupGPLXs,
        requestLookupTHUECNs,
        setRequestLookupTHUECNs,
        requestLookupDialog,
        setRequestLookupDialog,
        requestLookupData,
        setRequestLookupData,
    };

    // pass the value in provider and return
    return <RequestLookupContext.Provider value={requestLookupContext}>{children}</RequestLookupContext.Provider>;
};

export const { Consumer } = RequestLookupContext;
